export default {
    state: {
      profileData: {},
    },
  
    getters: {
      getProfileData(state) {
        return state.profileData;
      },
    },
  
    mutations: {
      setProfileData(state, data) {
        const isNull = data === null;
  
        state.profileData = {
          id: !isNull ? data.id : 0,
          name: !isNull ? data.name : "",
          description: !isNull ? data.description : "",
        };
      },
    },
  
    actions: {
      changeProfileData(context, infos) {
        context.commit("setProfileData", infos);
      },
    },
  };
  